import {useQuery} from "react-query";
import getPromise from "./getPromise";
import {ajax_url} from "../routes/CaseTypeList_Route";

const prefix_url = "/case_type";

export const useCaseTypes = (options={})=>{
    return useQuery(ajax_url, () => getPromise(prefix_url), options);
}
